import axios from '../plugins/axios'
// const URL = 'http://localhost:5000';
import i18n from '@/i18n'

export default class hidServices {

  async getNegeri() {
    try {
      const negeri = axios.get(`${process.env.VUE_APP_API_URL}/lookup/lookupnegeri`)
        return negeri
    } catch (err) {
      console.log(err)
    }
  }

  getRespons(){
    return [
      { "id": "0", "desc": `${i18n.t("Lain - lain (didiami)")}`},
      { "id": "1", "desc": `${i18n.t("Selesai")}`},
      { "id": "2", "desc": `${i18n.t("Kosong")}`},
      { "id": "3", "desc": `${i18n.t("Tiada siapa di rumah")}`},
      { "id": "4", "desc": `${i18n.t("Rumah dalam pembinaan")}`},
      { "id": "5", "desc": `${i18n.t("Bukan TK / TK Intitusi")}`},
      { "id": "6", "desc": `${i18n.t("Telah roboh / Rumah usang")}`},
      { "id": "7", "desc": `${i18n.t("Tidak Layak")}`},
      { "id": "8", "desc": `${i18n.t("Enggan Bekerjasama")}`},
      { "id": "9", "desc": `${i18n.t("Lain - lain")}`},
      { "id": "99", "desc": `${i18n.t("Belum Ditentukan")}`},


    ]

  }

  getHargasebenaranggaran(){
    return [
      { "id": "1", "desc": `${i18n.t("pilihanhargasebenar")}`},
      { "id": "2", "desc": `${i18n.t("pilihanhargaanggaran")}`},
      { "id": "0", "desc": `${i18n.t("pilihantiada")}`,"disabled": true},

    ]
  }

  getBulanBlok4(){
    return [
      { "id": "01", "desc": "Januari" },
      { "id": "02", "desc": "Februari" },
      { "id": "03", "desc": "Mac" },
      { "id": "04", "desc": "April" },
      { "id": "05", "desc": "Mei" },
      { "id": "06", "desc": "Jun" },
      { "id": "07", "desc": "Julai" },
      { "id": "08", "desc": "Ogos" },
      { "id": "09", "desc": "September" },
      { "id": "10", "desc": "Oktober" },
      { "id": "11", "desc": "November" },
      { "id": "12", "desc": "Disember" },
      { "id": "00", "desc": "Tiada"},

    ]
  }

  getBulan(){
    return [
      { "id": "01" },
      { "id": "02" },
      { "id": "03" },
      { "id": "04" },
      { "id": "05" },
      { "id": "06" },
      { "id": "07" },
      { "id": "08" },
      { "id": "09" },
      { "id": "10" },
      { "id": "11" },
      { "id": "12" },

    ]
  }

  getPuncapembelian(){
    return [
      { "id": "01", "desc": `${i18n.t("pasarbasah")}`},
      { "id": "02", "desc": `${i18n.t("pasarborong")}`},
      { "id": "03", "desc": `${i18n.t("pasartani")}`},
      { "id": "04", "desc": `${i18n.t("pasarmalam")}`},
      { "id": "05", "desc": `${i18n.t("kedairuncitdalampasarbasah")}`},
      { "id": "06", "desc": `${i18n.t("kedairuncit")}`},
      { "id": "07", "desc": `${i18n.t("kedairuncitakhbarpusatbelibelah")}`},
      { "id": "08", "desc": `${i18n.t("pasarmini")}`},
      { "id": "09", "desc": `${i18n.t("pasarraya")}`},
      { "id": "10", "desc": `${i18n.t("departmentalstore")}`},
      { "id": "11", "desc": `${i18n.t("kedaiconvenience")}`},
      { "id": "12", "desc": `${i18n.t("pasarrayabesar")}`},
      { "id": "13", "desc": `${i18n.t("kedaikhusus")}`},
      { "id": "14", "desc": `${i18n.t("restorankedaimakan")}`},
      { "id": "15", "desc": `${i18n.t("restoranbercawanganfoodcourt")}`},
      { "id": "16", "desc": `${i18n.t("geraikecilkaravan")}`},
      { "id": "17", "desc": `${i18n.t("restoran24jam")}`},
      { "id": "18", "desc": `${i18n.t("stesenpetrol")}`},
      { "id": "19", "desc": `${i18n.t("farmasi")}`},
      { "id": "20", "desc": `${i18n.t("pembelianatastalian")}`},
      { "id": "21", "desc": `${i18n.t("lainlain")}`},
      { "id": "00", "desc": `${i18n.t("pilihantiada")}`,"disabled": true},

    ]
  }

  getPuncalokasi(){
    return [
      { "id": "01", "desc": `${i18n.t("pasarbasah")}`},
      { "id": "02", "desc": `${i18n.t("pasarborong")}`},
      { "id": "03", "desc": `${i18n.t("pasartani")}`},
      { "id": "04", "desc": `${i18n.t("pasarmalam")}`},
      { "id": "05", "desc": `${i18n.t("kedairuncitdalampasarbasah")}`},
      { "id": "06", "desc": `${i18n.t("kedairuncit")}`},
      { "id": "07", "desc": `${i18n.t("kedairuncitakhbarpusatbelibelah")}`},
      { "id": "08", "desc": `${i18n.t("pasarmini")}`},
      { "id": "09", "desc": `${i18n.t("pasarraya")}`},
      { "id": "10", "desc": `${i18n.t("departmentalstore")}`},
      { "id": "11", "desc": `${i18n.t("kedaiconvenience")}`},
      { "id": "12", "desc": `${i18n.t("pasarrayabesar")}`},
      { "id": "13", "desc": `${i18n.t("kedaikhusus")}`},
      { "id": "14", "desc": `${i18n.t("restorankedaimakan")}`},
      { "id": "15", "desc": `${i18n.t("restoranbercawanganfoodcourt")}`},
      { "id": "16", "desc": `${i18n.t("geraikecilkaravan")}`},
      { "id": "17", "desc": `${i18n.t("restoran24jam")}`},
      { "id": "18", "desc": `${i18n.t("stesenpetrol")}`},
      { "id": "19", "desc": `${i18n.t("farmasi")}`},
      { "id": "20", "desc": `${i18n.t("pembelianatastalian")}`},
      { "id": "21", "desc": `${i18n.t("lainlain")}`},
      { "id": "00", "desc": `${i18n.t("pilihantiada")}`,"disabled": true},

    ]
  }

  // hes blk3 by arm
  getMediumpembayaran(){
    return [
      { "id": "01", "desc": `${i18n.t("bayaranterus")}`},
      { "id": "02", "desc": `${i18n.t("cekbankdraftkirimanwangwangpos")}`},
      { "id": "03", "desc": `${i18n.t("kadatmdebitkadprabayar")}`},
      { "id": "04", "desc": `${i18n.t("perbankanmenerusiintenet")}`},
      { "id": "05", "desc": `${i18n.t("kadkreditkadcaj")}`},
      { "id": "06", "desc": `${i18n.t("kreditselainkadkredit")}`},
      { "id": "07", "desc": `${i18n.t("sewabeli")}`},
      { "id": "08", "desc": `${i18n.t("percuma")}`},
      { "id": "09", "desc": `${i18n.t("lain2")}`},
      { "id": "00", "desc": `${i18n.t("pilihantiada")}`,"disabled": true},

    ]
  }
  getMediumBayaran(){
    //insert db guna id
    var data = [
      { "id": "01", "desc": "Bayaran Terus/Tunai" },
      { "id": "02", "desc": "Cek/Bank draft/Kiriman wang/ Wang pos" },
      { "id": "03", "desc": "Kad ATM/Debit/MAE/Kad pra bayar" },
      { "id": "04", "desc": "Pembayaran/Perbankan menerusi internet/Telefon internet/Mobile Payment/Banking" },
      { "id": "05", "desc": "Kredit selain dari menggunakan kad kredit" },
      { "id": "06", "desc": "Sewa beli" },
      { "id": "07", "desc": "Percuma" },
      { "id": "08", "desc": "Lain-lain (konsesi)" },
     // { "id": "10","desc":" Lain-lain (contoh : konsesi)" },	
                                    
    ]
    return data;
  }
  // hes blk3 by arm
  getEdagang() {
    return [
      { "id": "1", "desc": `${i18n.t("yesthrougheCommercetransactions")}`},
      { "id": "2", "desc": `${i18n.t("tidakmelaluitransaksidalamtalianlain")}`},
      { "id": "3", "desc": `${i18n.t("tidakbagikeduaduadiatas")}`},
      { "id": "0", "desc": `${i18n.t("pilihantiada")}`,"disabled": true},

    ]
  }

  getHubunganDenganKetuaIsiRumah() {
    var data = [
      { "id": "01", "desc": "	Ketua Isi Rumah" , "disabled": true},
      { "id": "02", "desc": "	Isteri/Suami Ketua" },
      { "id": "03", "desc": "	Anak Ketua yang belum berkahwin" },
      { "id": "04", "desc": "	Anak Ketua yang telah berkahwin" },
      { "id": "05", "desc": "	Menantu perempuan/lelaki ketua" },
      { "id": "06", "desc": "	Cucu Ketua" },
      { "id": "07", "desc": "	Bapa/Ibu Ketua atau Isteri/Suami Ketua" },
      { "id": "08", "desc": "	Datuk/Nenek Ketua atau Isteri/Suami Ketua" },
      { "id": "09", "desc": "	Abang/Kakak/Adik Ketua atau Isteri/Suami Ketua" },
      { "id": "10", "desc": "	Orang lain yang bersaudara dengan Ketua atau Isteri/Suami Ketua	" },
      { "id": "11", "desc": "	Pembantu rumah" },
      { "id": "12", "desc": "	Orang lain yang tidak bersaudara dengan Ketua atau Isteri/Suami Ketua" }
    ]

    return data;

  }

  getJantina() {
    //insert db guna id
    var data = [
      { "id": "1", "desc": "Lelaki" },
      { "id": "2", "desc": "Perempuan" },
    ]

    return data;

  }

  async getKumpulanEtnik() {
    //insert db guna kodEtnik

    try {
      //const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan`, {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getKumpulanEtnik`, {})
      var respData = res.data.data;
      var sortedData = respData.sort((a, b) => (a.kodEtnik > b.kodEtnik) ? 1 : -1)
      return sortedData;
    } catch (error) {
      return 'getData : ' + error;
    }

  }

  getKewarganegaraan() {
    //insert db guna id
    var data = [
      { "id": "1", "desc": "Warganegara" },
      { "id": "2", "desc": "Bukan Warganegara" },
    ];

    return data;
  }

  getResiden(){
     //insert db guna id
    var data = [
      {"id":"1","desc":"Penduduk Tetap"},			
      {"id":"2","desc":"Ekspatriat (Pegawai dagang)"},			
      {"id":"3","desc":"Pemastautin sementara"},			
      {"id":"4","desc":"Pelawat"},			
      {"id":"5","desc":"Pelajar Asing"},			
      {"id":"6","desc":"Pekerja Asing"},			
      {"id":"7","desc":"Lain-lain"}													
    ];

    return data;
  }
  
  getTarafPerkahwinan(){
    //insert db guna id
    var data = [
      {"id":"1","desc":"Tidak pernah berkahwin"},			
      {"id":"2","desc":"Berkahwin	"},		
      {"id":"3","desc":"Balu/Duda	"},		
      {"id":"4","desc":"Bercerai	"},		
      {"id":"5","desc":"Berpisah	"},		
												
    ];

    return data;

  }

  getJenisKetidakupayaan(){
    //insert db guna id
    var data = [
      {"id":"1","desc":"Pendengaran"},		
      {"id":"2","desc":"Penglihatan	"},	
      {"id":"3","desc":"Pertuturan"},		
      {"id":"4","desc":"Fizikal"},		
      {"id":"5","desc":"Pembelajaran	"},	
      {"id":"6","desc":"Mental"},
      {"id":"7","desc":"Pelbagai (nyatakan)"},		
      {"id":"8","desc":"Tidak berkenaan	"},	
    ];

    return data;
  }

  getPendaftaranOKU(){
    //insert db guna id
    var data = [
      {"id":"1","desc":"Berdaftar"},		
      {"id":"2","desc":"Tidak Bedaftar"},	
      {"id":"3","desc":"Tidak Berkenaan"},	

    ];

    return data;
  }

  getPersekolahan(){
    //insert db guna id
    var data = [
      {"id":"1",	"desc":"Ya, masih belajar (sepenuh masa)"},						
      {"id":"2",	"desc":"Ya, masih belajar (sambilan)"},						
      {"id":"3",	"desc":"Ya, telah tamat belajar	"},					
      {"id":"4",	"desc":"Tidak pernah bersekolah	"}				
    ];

    return data;
  }

  getSebabTidakBersekolah(){
    //insert db guna id
    var data = [
      {"id":"1","desc":"	Tidak mampu dari segi kewangan"},					
      {"id":"2","desc":"	Terlalu jauh dari institusi pendidikan	"},				
      {"id":"3","desc":"	Tidak berminat"},					
      {"id":"4","desc":"	Cacat"},					
      {"id":"5","desc":"	Perlu bekerja untuk menambah pendapatan keluarga"},					
      {"id":"6","desc":"	Tiada sijil kelahiran	"},				
      {"id":"7","desc":"	Masalah pengangkutan"},			
      {"id":"8","desc":"	Perlu menjaga ahli isi rumah yang sakit"},			
      {"id":"9","desc":"	Tidak berkenaan	"},				
        
    ];

    return data;
  }

  getJenisRumah(){
    //insert db guna id
   var data = [
     {"id":1,"desc":"Sesebuah"},										
     {"id":2,"desc":"Berkembar"},										
     {"id":3,"desc":"Teres"},										
     {"id":4,"desc":"Berangkai"},										
     {"id":5,"desc":"Berkelompok"},							
     {"id":6,"desc":"Rumah bandar"},										
     {"id":7,"desc":"Rumah pangsa"},										
     {"id":8,"desc":"Pangsapuri"},
     {"id":9,"desc":"Kondominium"},										
     {"id":10,"desc":"Pangsapuri khidmat"},										
     {"id":11,"desc":"SOHO/SOFO/SOVO"},										
     {"id":12,"desc":"Rumah kedai/pejabat"},										
     {"id":13,"desc":"Rumah panjang (Sabah & Sarawak sahaja)"},							
     {"id":14,"desc":"Pondok gantian/ sementara"},										
     {"id":15,"desc":"Bilik"},										
     {"id":16,"desc":"Rumah kampung air"},	
     {"id":17,"desc":"Lain-lain (cth:rumah rakit, kabin"},
     {"id":0,"desc":"--"},	

   ];

   return data;
 }

getJenisMilikanRumah(){
     //insert db guna id
    var data = [

   {"id":1,"desc":"Dimiliki"},
   {"id":2,"desc":"Disewa"},
   {"id":3,"desc":"Setinggan dimiliki"}, 
   {"id":4,"desc":"Setinggan disewa"}, 
   {"id":5,"desc":"Kuarters"}, 
   {"id":6,"desc":"Lain-lain (nyatakan)"},

    ];

    return data;
 }

getJarak(){
   //insert db guna id
   var data = [
    {"id":1,"desc":"Kurang 5km"},		
    {"id":2,"desc":"5 km - 10 km"},		
    {"id":3,"desc":"Lebih 10 km"},		
                                   
  ];

   return data;

 }

getMasa(){
   //insert db guna id
   var data = [
    {"id":1,"desc":"Kurang 30 minit"},		
    {"id":2,"desc":"30 minit - 1 jam"},		
    {"id":3,"desc":"Lebih 1 jam"},
                                   
  ];

   return data;

 }

 getPasarKekerapan(){
  //insert db guna id
  var data = [
   {"id":1,"desc":"1 kali seminggu"},		
   {"id":2,"desc":"2 kali seminggu"},		
   {"id":3,"desc":"3 kali seminggu"},	
   {"id":4,"desc":"Lebih dari 3 kali seminggu"},		
                                  
 ];

  return data;

}

 getKPB(){
   //insert db guna id
   var data = [
    {"id":1,"desc":"Setiap minggu atau kurang"},		
    {"id":2,"desc":"Setiap dua minggu"},		
    {"id":3,"desc":"Setiap bulan"},
    {"id":4,"desc":"Lebih dari sebulan"},
                                   
  ];

   return data;

 }

getyaTidakBerkenaan(){
   //insert db guna id
   var data = [

    {"id":1,"desc":"Ya"},
    {"id":2,"desc":"Tidak"}, 
    {"id":3,"desc":"Tidak Berkenaan"},

  ];

return data;

}

getKisahRumah(){
 //insert db guna id
 var data = [

    {"id":1,"desc":"Kukuh"},
    {"id":2,"desc":"Mulai Buruk"}, 
    {"id":3,"desc":"Buruk"},

  ];

return data;

}

getBinaanDindingRumah(){
 //insert db guna id
 var data = [
    {"id":1,"desc":"Batu-bata/ konkrit"},
    {"id":2,"desc":"Batu-bata dan papan"}, 
    {"id":3,"desc":"Papan"}, 
    {"id":4,"desc":"Lain-lain"},

  ];

return data;

}

getJenisTandas(){
 var data = [
    {"id":1,"desc":"Tandas moden/ mekanikal"},
    {"id":2,"desc":"Tandas curah"}, 
    {"id":3,"desc":"Lain-lain"},

  ];

return data;

}

getBekalanAir(){
  var data = [
    {"id":1,"desc":"Air paip dirawat dalam rumah"},
    {"id":2,"desc":"Paip/ pili air awam"}, 
    {"id":3,"desc":"Sumber lain"},

  ];

return data;

}

getAirMinuman(){
  var data = [
    {"id":1,"desc":"Air paip yang dirawat"},
    {"id":2,"desc":"Air paip yang ditapis (di luar TK)"}, 
    {"id":3,"desc":"Air paip yang ditapis (di dalam TK)"}, 
    {"id":4,"desc":"Sumber lain"},
    {"id":0,"desc":"--"},
    
  ];

return data;

}

getBekalanElektrik(){
 var data = [
   {"id":1,"desc":"24 jam sehari"},
   {"id":2,"desc":"Kurang dari 24 jam"}, 
   {"id":3,"desc":"Penjana kuasa individu"}, 
   {"id":4,"desc":"Solar"},  
   {"id":5,"desc":"Tiada"},

  ];

return data;

}

getSisaPepejal(){
 var data = [
   {"id":1,"desc":"Menggunakan kemudahan kutipan sampah"},										
   {"id":2,"desc":"Menggunakan semula sesetengah barang"},										
   {"id":3,"desc":"Menjual di pusat kitar semula"},										
   {"id":4,"desc":"Dibuang ke dalam tong pengasingan sisa yang telah disediakan oleh pihak berkuasa tempatan"},										
   {"id":5,"desc":"Membakar"},							
   {"id":6,"desc":"Membuang di dalam sungai/ aliran"},										
   {"id":7,"desc":"Membuang di dalam hutan"},										
   {"id":8,"desc":"Membuang di kawasan terbuka"},
   {"id":9,"desc":"Lain-lain"},		
   {"id":0,"desc":" - "},			
  
  ];
 
  return data;

}

getKutipanSampah(){
 var data = [
   {"id":1,"desc":"Ya, ke tempat kediaman ini"},
   {"id":2,"desc":"Ya, ke kawasan ini"}, 
   {"id":3,"desc":"Tiada"},
 
  ];

 return data;
 
}

getTahapKutipanSampah(){
  var data = [
    {"id":1,"desc":"Sangat tidak puas hati"},
    {"id":2,"desc":"Tidak puas hati"}, 
    {"id":3,"desc":"Puas hati"}, 
    {"id":4,"desc":"Sangat puas hati"},
    
  ];

  return data;
 
}

getSebabKutipanSampah(){
    var data = [
      {"id":1,"desc":"Limpahan sampah"},
      {"id":2,"desc":"Tidak mengikuti jadual"}, 
      {"id":3,"desc":"Tiada jadual"}, 
      {"id":4,"desc":"Kutipan tidak sempurna"},  
      {"id":5,"desc":"Lain-lain"},
      {"id":0,"desc":" - "},	
    
    ];

return data;
    
}

getKerap(){

    var data = [
      {"id":1,"desc":"Setiap minggu atau kurang"},
      {"id":2,"desc":"Setiap dua minggu"}, 
      {"id":3,"desc":"Setiap bulan"}, 
      {"id":4,"desc":"Lebih daripada sebulan"},
    
    ];

return data;

}


getSatisfaction(){

 var data = [
   {"id":1,"desc":"Sangat memuaskan"},
   {"id":2,"desc":"Memuaskan"},
   {"id":3,"desc":"Baik"},
   {"id":4,"desc":"Kurang memuaskan"},
   {"id":5,"desc":"Tidak memuaskan"}, 
   {"id":6,"desc":"Tidak berkaitan"},

  ];

 return data;

}

getRangkaian(){

  var data = [
    {"id":1,"desc":"Intranet dalam rumah/kawasan anda"},
    {"id":2,"desc":"Extranet di antara rumah/kawasan anda dan kawasan lain (termasuk kawasan yang berkenaan)"},
    {"id":3,"desc":"Rangkaian kawasan setempat"},
    {"id":4,"desc":"Rangkaian kawasan setempat tanpa wayar"},
    {"id":5,"desc":"Rangkaian kawasan luas"}, 
    {"id":6,"desc":"Lain-lain"},
 
   ];
 
  return data;
 
 }

getJenisPerkhidmatan(){
  //insert db guna id
  var data = [
    {"id":1,"desc":"Darat"},		
    {"id":2,"desc":"Air (laut/sungai)"},		
    {"id":3,"desc":"Udara"},
    {"id":0,"desc":" - "},			
                                   
  ];

   return data;

}
 getSektorPekerjaan(){
  //insert db guna id
  var data = [
   {"id":1,"desc":"HK2 - Aktiviti Pertanian (Tanaman/Ternakan/Nurseri)"},		
   {"id":2,"desc":"HK3 - Aktiviti Perikanan"},		
   {"id":3,"desc":"HK4 - Aktiviti ICT"},		
   {"id":4,"desc":"HK5 - Aktiviti Bukan Pertanian dan Bukan ICT (Pengangkutan)"},
   {"id":5,"desc":"HK6 - Aktiviti Bukan Pertanian dan Bukan ICT (Lain-lain)"},
  //  {"id":6,"desc":"Kegunaan Sendiri"},
  //  {"id":7,"desc":"Pendapatan Lain"}
                                  
  ]

  return data;

}


  async getTarafPendidikan(){
    //insert db guna kodPendidikan
    try {
      //const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan`, {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getTarafPendidikan`, {})
      var respData = res.data.data;
      var sortedData = respData.sort((a, b) => (a.kodPendidikan > b.kodPendidikan) ? 1 : -1)
      return sortedData;
    } catch (error) {
      return 'getData : '+ error;
    }

  }

  async getSijilTertinggi(){
    //insert db guna kodSijil
    try {
      //const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan`, {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getSijilTertinggi`, {})
        return res.data.data;
    } catch (error) {
      return 'getData : '+ error;
    }

  }

  async getAktiviti() {
    //insert db guna kod_aktiviti
    try {
      //const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan`, {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getAktiviti`, {})
      return res.data.data;
    } catch (error) {
      return 'getData : ' + error;
    }

  }

  getKesanCovidTerhadapPekerjaan() {
    //insert db guna id
    var data = [
      { "id": "1", "desc": "Tiada impak, bekerja seperti biasa" },
      { "id": "2", "desc": "Masih bekerja, tetapi jumlah jam bekerja telah berkurangan" },
      { "id": "3", "desc": "Masih bekerja, tetapi jumlah jam bekerja telah bertambah" },
      { "id": "4", "desc": "Masih bekerja, tetapi bertukar pekerjaan" },
      { "id": "5", "desc": "Bekerja dari rumah			" },
      { "id": "6", "desc": "Cuti tanpa gaji" },
      { "id": "7", "desc": "Cuti separuh gaji" },
      { "id": "8", "desc": "Kehilangan pekerjaan" }
    ];

    return data;
  }

  getKesanCovidTerhadapPendapatan() {
    //insert db guna id
    var data = [
      { "id": "1", "desc": "Tiada  perubahan" },
      { "id": "2", "desc": "Pengurangan pendapatan bulanan" },
      { "id": "3", "desc": "Pertambahan pendapatan bulanan" },

    ];

    return data;
  }

  getYaTidak() {
    //insert db guna id
    var data = [
      { "id": 1, "desc": "Ya" },
      { "id": 2, "desc": "Tidak" },
    ]

    return data;

  }

  getDagang(){
    //insert db guna id
    var data = [
      { "id": "1", "desc": "Ya, melalui transaksasi e-dagang" },
      { "id": "2", "desc": "Tidak, melalui transaksi dalam talian" },
      { "id": "3", "desc": "Tidak bagi kedua-dua di atas" },	
                                    
    ]

    return data;

  }



  getPuncaBeli(){
    //insert db guna id
    var data = [
      { "id": "01", "desc": "Pasar Basah" },
      { "id": "02", "desc": "Pasar Borong" },
      { "id": "03", "desc": "Pasar Tani/ Pasar Tamu" },	
      { "id": "04", "desc": "Pasar Malam" },	
      { "id": "05", "desc": "Kedai Runcit di dalam Pasar Basah/ Pasar Borong" },	
      { "id": "06", "desc": "Kedai Runcit" },	
      { "id": "07", "desc": "Kedai Runcit/ Akhbar di Pusat Beli Belah" },	
      { "id": "08", "desc": "Pasar Mini" },	
      { "id": "09", "desc": "Pasar Raya" },	
      { "id": "10", "desc": "Departmental Store" },	
      { "id": "11", "desc": "Kedai Convenience" },	
      { "id": "12", "desc": "Pasar Raya Besar" },	
      { "id": "13", "desc": "Kedai Khusus" },	
      { "id": "14", "desc": "Restoran/ Kedai Makan" },	
      { "id": "15", "desc": "Restoran Bercawangan/ Food Court" },	
      { "id": "16", "desc": "Gerai Kecil/ Karavan/ Foodtruck/ Kiosk" },	
      { "id": "17", "desc": "Restoran Berhawa Dingin/ Restoran 24 Jam" },	
      { "id": "18", "desc": "Stesen Petrol" },	
      { "id": "19", "desc": "Farmasi" },	
      { "id": "20", "desc": "Pembelian atas talian/ Pembelian melalui tempahan" },	
      { "id": "21", "desc": "Lain-lain" },	
                                    
    ]

    return data;

  }

  getCost(){
    //insert db guna id
    var data = [
      {"id":"1","desc":"RM1"},		
      {"id":"2","desc":"RM5	"},	
      {"id":"3","desc":" RM30 dan keatas (nyatakan) "},		
    ];

    return data;
  }

  getCostSwasta(){
    //insert db guna id
    var data = [
      {"id":"1","desc":"RM0 - RM50"},		
      {"id":"2","desc":"RM50 - RM100	"},	
      {"id":"3","desc":" RM100 dan keatas (nyatakan) "},		
    ];

    return data;
  }

  getBBM(){
    //insert db guna id
    var data = [
      { "id": "1", "desc": "Sehari" },
      { "id": "2", "desc": "Seminggu" },
      { "id": "3", "desc": "Dua minggu" },	
      { "id": "4", "desc": "Sebulan" },	
      { "id": "5", "desc": "Lebih dari sebulan" },	                              
    ]
   return data;
  }

  getPuncaPembaziran(){

    var data = [

      { "id": "1", "desc": "Makanan tamat tempoh" },
      { "id": "2", "desc": "Pembelian berlebihan" },
      { "id": "3", "desc": "Rasa makanan berbeza daripada penampilannya" },	
      { "id": "4", "desc": "Pembaziran makanan disebabkan oleh kesan trend viral" },	
      { "id": "5", "desc": "Makanan ditinggalkan di dalam peti sejuk terlalu lama" },	 
      { "id": "6", "desc": "Kemahiran memasak yang lemah" },
      { "id": "7", "desc": "Amalan  penyimpanan makanan kurang baik " },
      { "id": "8", "desc": "Perlabelan menimbulkan kekeliruan" },	
      { "id": "9", "desc": "Lain-lain" },	
      { "id": "0", "desc": " - " },


    ]

    return data;
  }
  
  async getMasco(){
    //insert db guna kod

    if (localStorage.getItem("masco") === null) {
     
      try {
        //const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan`, {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getMasco`, {})
        var respData = res.data.data;
        var sortedData = respData.sort((a, b) => (a.keterangan > b.keterangan) ? 1 : -1)
        
        window.localStorage.setItem('masco', JSON.stringify(sortedData));
        return sortedData;
      } catch (error) {
        return 'getData : '+ error;
      }

    }else{

      var dataMasco = [];
      dataMasco = JSON.parse(localStorage.getItem('masco'));
      return dataMasco;

    }
    

  }

  async getMsic(){
    //insert db guna kod_industri

    if (localStorage.getItem("msic") === null) {
     
      try {
        //const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan`, {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getMsic`, {})
        var respData = res.data.data;
        var sortedData = respData.sort((a, b) => (a.keterangan > b.keterangan) ? 1 : -1)
        
        window.localStorage.setItem('msic', JSON.stringify(sortedData));
        return sortedData;
      } catch (error) {
        return 'getData : '+ error;
      }

    }else{

      var dataMasco = [];
      dataMasco = JSON.parse(localStorage.getItem('msic'));
      return dataMasco;

    }
  }


  async getKodItemBlok3(){
    //insert db guna kod

    if (localStorage.getItem("KodItemBlok3") === null) {
     
      try {
        //const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan`, {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getKodItemBlok3`, {})
        var respData = res.data.data;
        var sortedData = respData.sort((a, b) => (a.keterangan > b.keterangan) ? 1 : -1)
        
        window.localStorage.setItem('KodItemBlok3', JSON.stringify(sortedData));
        return sortedData;
      } catch (error) {
        return 'getData : '+ error;
      }

    }else{

      var dataKodItemBlok3 = [];
      dataKodItemBlok3 = JSON.parse(localStorage.getItem('dataKodItemBlok3'));
      return dataKodItemBlok3;

    }
    

  }

  //latest guna ni
  async getlookupBlok3(){
    //insert db guna kod
    if (localStorage.getItem("lookupBlok3") === null) {
      try {
        //const res = await axios.get(`${process.env.VUE_APP_API_URL}/blk/lookupkoditem4a`)
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getKodItemBlok3`, {})
        var respData = res.data.data;
        var sortedData = respData.sort((a, b) => (a.KodItem > b.KodItem) ? 1 : -1)//sorting
        
        window.localStorage.setItem('lookupBlok3', JSON.stringify(sortedData));
        return sortedData;
      } catch (error) {
        return 'getData : '+ error;
      }
    }else{
      var datalookupBlok3 = [];
      datalookupBlok3 = JSON.parse(localStorage.getItem('lookupBlok3'));
      return datalookupBlok3;
    }
  }

  async getKodItemBlok3PreCode(){
    //insert db guna kod

    //if (localStorage.getItem("KodItemBlok3PreCode") === null) {
      if (localStorage.getItem("lookupBlok3PreCode") === null) {
     
      try {
        //const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan`, {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getKodItemBlok3PreCode`, {})
        var respData = res.data.data;
        var sortedData = respData.sort((a, b) => (a.keterangan > b.keterangan) ? 1 : -1)
        
        window.localStorage.setItem('lookupBlok3PreCode', JSON.stringify(sortedData));
        //window.localStorage.setItem('KodItemBlok3', JSON.stringify(sortedData));

        return sortedData;
      } catch (error) {
        return 'getData : '+ error;
      }

    }else{

      var dataKodItemBlok3PreCode = [];
      //dataKodItemBlok3PreCode = JSON.parse(localStorage.getItem('dataKodItemBlok3PreCode'));
      dataKodItemBlok3PreCode = JSON.parse(localStorage.getItem('lookupBlok3PreCode'));
      return dataKodItemBlok3PreCode;

    }
    

  }

  //latest guna ni
  async getlookupBlok3PreCode(){
    //insert db guna kod
    if (localStorage.getItem("lookupBlok3PreCode") === null) {
      try {
        //const res = await axios.get(`${process.env.VUE_APP_API_URL}/blk/lookupkoditem4a`)
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getKodItemBlok3PreCode`, {})
        var respData = res.data.data;
        var sortedData = respData.sort((a, b) => (a.KodItem > b.KodItem) ? 1 : -1)//sorting
        
        window.localStorage.setItem('lookupBlok3PreCode', JSON.stringify(sortedData));
        return sortedData;
      } catch (error) {
        return 'getData : '+ error;
      }
    }else{
      var datalookupBlok3PreCode = [];
      datalookupBlok3PreCode = JSON.parse(localStorage.getItem('lookupBlok3PreCode'));
      return datalookupBlok3PreCode;
    }
  } 

  async getKodItemBlok4a(){
    //insert db guna kod
    if (localStorage.getItem("KodItemBlok4a") === null) {
      try {
        //const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan`, {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getKodItemBlok4a`, {})
        var respData = res.data.data;
        var sortedData = respData.sort((a, b) => (a.keterangan > b.keterangan) ? 1 : -1)
        
        window.localStorage.setItem('KodItemBlok4a', JSON.stringify(sortedData));
        return sortedData;
      } catch (error) {
        return 'getData : '+ error;
      }
    }else{
      var dataKodItemBlok4a = [];
      dataKodItemBlok4a = JSON.parse(localStorage.getItem('dataKodItemBlok4a'));
      return dataKodItemBlok4a;
    }
  }

  //latest guna ni
  async getlookupBlok4a(){
    //insert db guna kod
    if (localStorage.getItem("lookupBlok4a") === null) {
      try {
        //const res = await axios.get(`${process.env.VUE_APP_API_URL}/blk/lookupkoditem4a`)
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getKodItemBlok4a`, {})
        var respData = res.data.data;
        var sortedData = respData.sort((a, b) => (a.KodItem > b.KodItem) ? 1 : -1)//sorting
        
        window.localStorage.setItem('lookupBlok4a', JSON.stringify(sortedData));
        return sortedData;
      } catch (error) {
        return 'getData : '+ error;
      }
    }else{
      var datalookupBlok4a = [];
      datalookupBlok4a = JSON.parse(localStorage.getItem('lookupBlok4a'));
      return datalookupBlok4a;

    }
  }

  async getlookupBlok4b(){
    //insert db guna kod
    if (localStorage.getItem("lookupBlok4b") === null) {
      try {
        //const res = await axios.get(`${process.env.VUE_APP_API_URL}/blk/lookupkoditem4a`)
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getKodItemBlok4b`, {})
        var respData = res.data.data;
        var sortedData = respData.sort((a, b) => (a.KodItem > b.KodItem) ? 1 : -1)//sorting
        
        window.localStorage.setItem('lookupBlok4b', JSON.stringify(sortedData));
        return sortedData;
      } catch (error) {
        return 'getData : '+ error;
      }
    }else{
      var datalookupBlok4b = [];
      datalookupBlok4b = JSON.parse(localStorage.getItem('lookupBlok4b'));
      return datalookupBlok4b;
    }
  }

  async getlookupBlok4c(){
    //insert db guna kod
    if (localStorage.getItem("lookupBlok4c") === null) {

      try {
        //const res = await axios.get(`${process.env.VUE_APP_API_URL}/blk/lookupkoditem4a`)
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getKodItemBlok4c`, {})
        var respData = res.data.data;
        var sortedData = respData.sort((a, b) => (a.KodItem > b.KodItem) ? 1 : -1)//sorting
        
        window.localStorage.setItem('lookupBlok4c', JSON.stringify(sortedData));
        return sortedData;
      } catch (error) {
        return 'getData : '+ error;
      }
    }else{

      var datalookupBlok4c = [];
      datalookupBlok4c = JSON.parse(localStorage.getItem('lookupBlok4c'));


      return datalookupBlok4c;
    }
  }


  async getPoskod(kodNeg){
 
    
    try {
      //const res = await axios.get(`${process.env.VUE_APP_API_URL}/pusingan`, {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/lookup/getPoskod?kodNeg=`+kodNeg, {})
      var respData = res.data.data;
      return respData;

    } catch (error) {
      console.log(error)
      //return 'getData : '+ error;
    }

  }


  getS19i(){

    var data = [
      { "id": "0", "desc": "Tiada" },
      { "id": "1", "desc": "Satu" },
      { "id": "2", "desc": "Dua" },
      { "id": "3", "desc": "Tiga atau lebih" },
    ];

    return data;

  }



}